import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	getPropertyV2,
	type PortfolioReportingOverviewTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePropertyListQuery = (
	filterDatagroups?: PortfolioReportingOverviewTypeEnum[],
	filterOnlyreportingenabled?: boolean,
	enabled = true,
) => {
	return useQuery({
		queryKey: PortfolioKeys.propertyList(
			filterDatagroups,
			filterOnlyreportingenabled,
		),
		queryFn: ({ signal }) =>
			processResponse(() =>
				getPropertyV2(filterDatagroups, filterOnlyreportingenabled, { signal }),
			)(undefined),
		enabled,
	});
};
